import stickyHeader from "../../jquery/lsag.stickyHeader";
import Modal from 'bootstrap/js/src/modal';

class HeaderNavigationController {
    /*@ngInject*/
    constructor($log, $rootScope, HeaderNavigationService, CommonService) {
        $log.debug('HeaderNavigationController initialized');
        this.$log = $log;
        this.headerNavigationService = HeaderNavigationService;
        this.commonService = CommonService;
        this.isLoggedIn = false;
        this.isInYourClub = false;
        this.isRequestSuccess = false;
        this.modalLogin = $('#modal-login');

        // init login modal
        // ES5 way
        // this.modalLogin.modal({
        //     show: false
        // });
        if (this.modalLogin.length) {
            new Modal(this.modalLogin[0], {
                show: false
            });
        }
        this.modalLogin.on('hidden.bs.modal', function (e) {
            stickyHeader.stickSave();
        });

        $rootScope.$on('personalizeRequestSuccess', () => {
            this.isLoggedIn = this.commonService.getPersonalizeRequestResponse().isLoggedIn;
            this.isInYourClub = this.commonService.getPersonalizeRequestResponse().isInYourClub;
            this.userName = this.commonService.getPersonalizeRequestResponse().firstName + ' ' + this.commonService.getPersonalizeRequestResponse().lastName;
            this.isRequestSuccess = true;
        });

        // forgotten password process needs to close the modal window
        $rootScope.$on('hideLoginModal', () => {
            if (this.modalLogin.length) {
                this.hideLoginOverlay();
            }
        });
    }

    showLoginOverlay() {
        this.modalLogin.modal('show');
        stickyHeader.unstickSave();
    }

    hideLoginOverlay() {
        this.modalLogin.modal('hide');
        stickyHeader.stickSave();
    }

    getIsLoggedIn() {
        return this.isLoggedIn;
    }

    getIsInYourClub() {
        return this.isInYourClub;
    }

    getUserName() {
        return this.userName;
    }

    getIsRequestSuccess() {
        return this.isRequestSuccess;
    }
}

export default HeaderNavigationController;
